(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/map-single.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/map-single.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useState = _React.useState;
const getResultMapHandler = svs.lyckoplatsen.components.shared_map.getResultMapHandler;
const PinIcon = svs.lyckoplatsen.shared_utils.react.components.PinIcon;
const Button = svs.ui.ReactButton;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue,
  useAtom = _jotai.useAtom;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_result.jotai.atoms,
  correctionStepAtom = _svs$lyckoplatsen$com.correctionStepAtom,
  selectedHighlightedWinGroupAtom = _svs$lyckoplatsen$com.selectedHighlightedWinGroupAtom;
const mapErrorDialogNoRedirect = svs.lyckoplatsen.shared_map.utils.mapErrorDialogNoRedirect;
const MapSingle = _ref => {
  let _ref$mapId = _ref.mapId,
    mapId = _ref$mapId === void 0 ? 'map-single-pin' : _ref$mapId,
    _ref$wagers = _ref.wagers,
    wagers = _ref$wagers === void 0 ? null : _ref$wagers,
    result = _ref.result,
    _ref$showBtnCenterSwe = _ref.showBtnCenterSweden,
    showBtnCenterSweden = _ref$showBtnCenterSwe === void 0 ? false : _ref$showBtnCenterSwe;
  const mapHandlerResult = useMemo(() => getResultMapHandler(), []);
  const _useAtom = useAtom(selectedHighlightedWinGroupAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    highlightedWinGroup = _useAtom2[0],
    setHighlightedWinGroup = _useAtom2[1];
  const correctionStep = useAtomValue(correctionStepAtom);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showCenterSwedenButton = _useState2[0],
    setShowCenterSwedenButton = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showCenterWagersButton = _useState4[0],
    setShowCenterWagersButton = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showCenterWinCircleButton = _useState6[0],
    setShowCenterWinCircleButton = _useState6[1];
  const _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    mapCenter = _useState8[0],
    setMapCenter = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    circlesReady = _useState0[0],
    setCirclesReady = _useState0[1];
  const winGroupClass = highlightedWinGroup || highlightedWinGroup === 0 ? "lp-wingroup-".concat(highlightedWinGroup) : '';
  const handleCenterSwedenClick = () => {
    mapHandlerResult.centerSweden();
  };
  const handleCenterWinCircleClick = () => {
    setMapCenter(true);
    mapHandlerResult.centerWinCircle();
    if (highlightedWinGroup !== null) {
      setHighlightedWinGroup(null);
    }
  };
  const handleCenterWagersClick = () => {
    setMapCenter(false);
    mapHandlerResult.centerWagers();
    setHighlightedWinGroup(null);
  };

  useEffect(() => {
    const mapOptions = {
      nodeId: mapId,
      geoJsonInv: true,
      maxBounds: [[72.1, -5.5], [47.1, 39.5]],
      maxZoom: 15,
      minZoom: 4,
      zoomSnap: 0.25,
      dragging: true,
      boxZoom: true,
      touchZoom: true,
      showErrorOverlay: false,
      errorCallback: mapErrorDialogNoRedirect
    };
    const evtHandlers = {
      highlightedWinGroup: index => setHighlightedWinGroup(index),
      showCenterSwedenButton: bool => setShowCenterSwedenButton(bool),
      showCenterWagersButton: bool => setShowCenterWagersButton(bool),
      showCenterWinCircleButton: bool => setShowCenterWinCircleButton(bool),
      resultRendered: () => {
        setCirclesReady(true);
      }
    };
    mapHandlerResult.createMap({
      mapOptions,
      evtHandlers
    });
    return () => mapHandlerResult.removeMap();
  }, [mapHandlerResult, mapId, setHighlightedWinGroup, result]);
  useEffect(() => {
    if (result && correctionStep) {
      const winGroups = result.distribution;
      const winningLocation = result.location;
      mapHandlerResult.showResult({
        winGroups,
        winningLocation
      });
    }
    if (!correctionStep) {
      mapHandlerResult.fitBoundsSweden();
    }
  }, [correctionStep, mapHandlerResult, result]);
  useEffect(() => {
    if (wagers) {
      mapHandlerResult.showWagers(wagers, result);
      return () => mapHandlerResult.removeWagers();
    }
  }, [mapHandlerResult, wagers, result]);


  useEffect(() => {
    if (!mapCenter && highlightedWinGroup !== null && highlightedWinGroup !== 'zoomed') {
      setMapCenter(true);
    }
  }, [highlightedWinGroup, mapCenter]);
  useEffect(() => {
    if (highlightedWinGroup === 0) {
      mapHandlerResult.selectSinglePin();
      mapHandlerResult.moveToWinGroup(0);
      return () => mapHandlerResult.clearSelectedSinglePin();
    }
    if (highlightedWinGroup === 'zoomed') {
      mapHandlerResult.moveToWinGroup(0, true);
    } else if (result && correctionStep && circlesReady && mapCenter) {
      mapHandlerResult.moveToWinGroup(highlightedWinGroup);
    }
  }, [correctionStep, highlightedWinGroup, mapHandlerResult, result, circlesReady, mapCenter]);

  useEffect(() => {
    if (wagers && correctionStep && circlesReady) {
      mapHandlerResult.centerWagers();
    }
  }, [correctionStep, mapHandlerResult, circlesReady, wagers]);
  return React.createElement("div", {
    className: "result-map ".concat(winGroupClass, " ").concat(wagers ? 'has-wagers' : '')
  }, React.createElement("div", {
    id: mapId,
    style: {
      height: '100%',
      width: '100%'
    }
  }), correctionStep !== 0 && React.createElement(Button, {
    disabled: !showCenterWinCircleButton,
    className: "lp-btn-center-map ".concat(showCenterWinCircleButton ? '' : 'disable'),
    onClick: handleCenterWinCircleClick
  }, React.createElement(PinIcon, {
    color: "green"
  })), wagers && React.createElement(Button, {
    disabled: !showCenterWagersButton,
    className: "lp-btn-center-wagers ".concat(showCenterWagersButton ? '' : 'disable'),
    onClick: handleCenterWagersClick
  }, React.createElement(PinIcon, {
    color: "red"
  })), showBtnCenterSweden && React.createElement(Button, {
    disabled: !showCenterSwedenButton,
    className: "lp-btn-center-sweden ".concat(showCenterSwedenButton ? '' : 'disable'),
    onClick: handleCenterSwedenClick
  }, React.createElement("svg", {
    fill: "#FFFFFF",
    viewBox: "0 0 112 260",
    enableBackground: "new 0 0 112 260",
    xmlSpace: "preserve",
    role: "img",
    "aria-labelledby": "center-map-icon-title"
  }, React.createElement("title", {
    id: "center-map-icon-title"
  }, "Knappen: Visa hela Sverige"), React.createElement("polygon", {
    points: "109.627,57.925 104.224,46.74 105.859,39.394 95.337,12.782 88.204,10.294 79.555,2 75.692,3.421 73.773,14.085 61.474,11.431 47.872,32.711 50.099,39.583 43.346,52.711 36.308,57.001 34.53,75.864 28.891,85.698 31.094,96.456 20.739,97.191 14.506,109.395 16.426,128.495 14.648,138.661 20.762,145.486 16.592,168.756 8.321,178.827 9.293,184.681 2.373,189.562 2.61,200.179 8.866,203.923 8.843,215.795 18.203,236.838 18.345,255.511 21.497,258 33.037,254.872 35.123,245.014 48.654,244.35 56.758,218.354 57.114,196.648 72.517,186.6 76.617,174.941 66.545,159.609 61.569,159.348 58.607,144.964 61.593,130.888 61.829,125.248 75.811,105.627 87.304,97.001 92.304,86.267 91.593,74.086 96.024,58.636 "
  }))));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  MapSingle
});

 })(window);